import React from 'react'
import Classes from 'classnames'

import FormManager from "../../common/form-manager"

type Props = {
    className?          : string

    form?               : FormManager
    name?               : string
    placeholder?        : string

    value?              : string        // if no form

    rows?               : number
    cols?               : number

    size?               : 'big' | 'normal' | '2-rows'

    autosize?           : boolean       // the height fits the content - grows and shrinks with it
    noResizeControl?    : boolean
    autoFocus?          : boolean

    onClick?            : callback
}

export default class FormTextArea extends React.Component<Props> {

    static defaultProps = {
        rows            : 4,
        cols            : 50,
        size            : 'normal',
        autosize        : false,
        noResizeControl : false,
        autoFocus       : false,
    }

    // public - callers reach the DOM node through the component ref, e.g. to focus it
    textarea: HTMLTextAreaElement

    constructor(props: Props) {
        super(props)

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name, this)
        }
    }

    componentDidMount() {
        if (this.props.autosize) {
            this.autoSizeHeight()
        }
        return
    }

    autoSizeHeight = () => {
        // reset first, so scrollHeight measures the content and the field can shrink as well as
        // grow; offsetHeight - clientHeight adds the borders back, the box is border-box
        this.textarea.style.height = 'auto'
        this.textarea.style.height = (this.textarea.scrollHeight + this.textarea.offsetHeight - this.textarea.clientHeight) + "px"
        return
    }

    _update = (newValue: string) => {
        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.name, newValue)
        }

        if (this.props.autosize) {
            this.autoSizeHeight()
        }

        this.forceUpdate() // we need to re-render the field because it's BASIC control
        return
    }

    insert = (value: string) => {
        const textarea      = this.textarea
        const contentLength = textarea.value.length

        textarea.focus()
        textarea.value = textarea.value.substr(0, textarea.selectionStart)
            + value
            + textarea.value.substring(textarea.selectionStart, contentLength)

        this._update(textarea.value)
        return
    }

    onClick = () => {
        if (this.props.onClick) {
            this.props.onClick()
        }
        return
    }

    onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this._update(event.target.value)
        return
    }

    render() {
        const value = this.props.form
            ? this.props.form.getValue(this.props.name)
            : this.props.value

        const classes = Classes('gd-textarea', 'size-' + this.props.size, this.props.className, {
            'auto-size' : this.props.autosize,
            'no-resize' : this.props.noResizeControl,
        })

        return (
            <textarea ref={(r)=> {
                          this.textarea = r
                          return
                      }}
                      className     = {classes}
                      rows          = {this.props.rows}
                      cols          = {this.props.cols}
                      value         = {value || ''}        // null would make React warn
                      placeholder   = {this.props.placeholder}
                      autoFocus     = {this.props.autoFocus}
                      onChange      = {this.onChange}
                      onClick       = {this.onClick}/>
        )
    }
}
